<h2 mat-dialog-title class="text-2xl md:text-5xl font-semibold tracking-tight leading-7 md:leading-snug truncate">Cliente</h2>
<div mat-dialog-content>
  <!-- <app-spinner-utileria *ngIf="spinner"></app-spinner-utileria> -->
<div class="flex flex-col flex-auto min-w-0">
    <div class="bg-card">
        <div class="flex flex-col min-w-0 ml-4">
            <ng-container *transloco="let t">
                <!-- <div class="text-2xl md:text-5xl font-semibold tracking-tight leading-7 md:leading-snug truncate">
                    {{t('Nuevo Cliente')}}</div> -->
            </ng-container>
        </div>
        <br>
        <mat-card-content>
            <h5>Datos generales</h5>
            <form [formGroup]="formDatosCliente" class="row d-flex justify-content-start align-items-center">
                <div class="col-sm-12 col-md-12 col-xl-12 ">
                    <mat-form-field class="custom-field" appearance="fill"><!--outline-->
                        <mat-label>Nombre / Razón Social:</mat-label>
                        <input matInput placeholder="Nombre / Razón Social" formControlName="nombreRazonSocial"
                            oninput="this.value = this.value.toUpperCase()"
                            onkeypress="return /^[a-zA-Z\s]*$/gi.test(event.key)" minlength="1">
                        <mat-error *ngIf="formDatosCliente.get('nombreRazonSocial').hasError ('required')"><strong>*Este
                                campo es obligatorio</strong></mat-error>
                    </mat-form-field>
                </div>

                <div class="col-sm-12 col-md-6 col-xl-6 ">
                    <mat-form-field class="custom-field" appearance="fill">
                        <mat-label>RFC:</mat-label>
                        <input matInput placeholder="RFC" formControlName="rFC" maxlength="13" minlength="12"
                            [attr.readonly]= "isRfcReadOnly"
                            oninput="this.value = this.value.toUpperCase()"
                            pattern="^([A-ZÑ&]{3,4}\d{6}[A-Z0-9]{3})$"
                            (blur)="getUsoCfdiYRegimenFiscal(formDatosCliente.get('rFC').value)"
                            onkeypress="return ((event.charCode >= 48 && event.charCode <= 57) || (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122))">
                        <mat-error *ngIf="formDatosCliente.get('rFC').hasError ('required')"><strong>*Este campo es
                                obligatorio</strong></mat-error>
                        <mat-error *ngIf="formDatosCliente.get('rFC').hasError ('minlength')"><strong>*Este campo
                                requiere un minimo de
                                12 caractere</strong></mat-error>
                        <mat-error *ngIf="formDatosCliente.get('rFC').hasError ('pattern')"><strong>*RFC Incorrecta
                                verifique</strong></mat-error>
                    </mat-form-field>
                </div>

                <div class="col-sm-12 col-md-6 col-xl-6 ">
                    <mat-form-field class="custom-field" appearance="fill">
                        <mat-label>Uso de factura:</mat-label>
                        <mat-select placeholder="Seleccionar uso de la factura" formControlName="usoDeLaFactura">
                            <mat-option *ngFor="let factura of usoFactura" [value]="factura.id">
                                {{ factura.attributes.clave }} - {{ factura.attributes.descripcion }}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="formDatosCliente.get('usoDeLaFactura').hasError ('required')"><strong>*Este
                                campo es obligatorio</strong></mat-error>
                    </mat-form-field>
                </div>

                <div class="col-sm-12 col-md-12 col-xl-12 ">
                    <mat-form-field class="custom-field" appearance="fill">
                        <mat-label>Régimen fiscal:</mat-label>
                        <mat-select placeholder="Seleccionar Uso de la factura" formControlName="regimenFiscal">
                            <!-- <mat-option [value]=0>
                                Selecciona el Régimen fiscal
                            </mat-option> -->
                            <mat-option *ngFor="let regimenFiscal of regFiscal" [value]="regimenFiscal.id">
                                {{ regimenFiscal.attributes.clave }} - {{ regimenFiscal.attributes.descripcion }}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="formDatosCliente.get('regimenFiscal').hasError ('required')"><strong>*Este
                                campo es obligatorio</strong></mat-error>
                    </mat-form-field>
                </div>

                <div class="col-sm-12 col-md-6 col-xl-6 ">
                    <mat-form-field class="custom-field" appearance="fill">
                        <mat-label>E-Mail:</mat-label>
                        <input type="email" [email]="true" matInput placeholder="E-Mail" formControlName="eMail"
                            onkeyup="if(this.value.length > 40){
                            this.value= this.value.slice(0,40)}">
                        <mat-error *ngIf="formDatosCliente.get('eMail').hasError ('required')"><strong>*Este campo es
                                obligatorio</strong></mat-error>
                        <mat-error *ngIf="formDatosCliente.get('eMail').hasError ('email')  "><strong>*El correo no es
                                válido</strong></mat-error>
                    </mat-form-field>
                </div>

                <div class="col-sm-12 col-md-6 col-xl-6 ">
                    <mat-form-field class="custom-field" appearance="fill">
                        <mat-label>E-Mail opcional No.1:</mat-label>
                        <input type="email" [email]="true" matInput placeholder="E-Mail"
                            formControlName="eMailOpcionalNo1" onkeyup="if(this.value.length > 40){
                           this.value= this.value.slice(0,40)}">
                        <mat-error *ngIf="formDatosCliente.get('eMailOpcionalNo1').hasError ('email')  "><strong>*El
                                correo no es válido</strong></mat-error>
                    </mat-form-field>
                </div>

                <div class="col-sm-12 col-md-6 col-xl-6 ">
                    <mat-form-field class="custom-field" appearance="fill">
                        <mat-label>E-Mail opcional No.2:</mat-label>
                        <input type="email" [email]="true" matInput placeholder="E-Mail"
                            formControlName="eMailOpcionalNo2" onkeyup="if(this.value.length > 40){
                           this.value= this.value.slice(0,40)}">
                        <mat-error *ngIf="formDatosCliente.get('eMailOpcionalNo2').hasError ('email')  "><strong>*El
                                correo no es válido</strong></mat-error>
                    </mat-form-field>
                </div>

                <div class="col-sm-12 col-md-3 col-xl-3 ">
                    <mat-form-field class="custom-field" appearance="fill">
                        <mat-label>C.P:</mat-label>
                        <input matInput placeholder="C.P" formControlName="cP"
                            oninput="this.value = this.value.toUpperCase()"
                            maxlength="5"
                            onkeypress="return ((event.charCode >= 48 && event.charCode <= 57) || (event.charCode >= 65 && event.charCode <= 90) ||
                            (event.charCode >= 97 && event.charCode <= 122) || (event.charCode == 32 || event.charCode == 209 || event.charCode == 241))"
                            (keyup)="KeyUpCP($event)">

                            <mat-error *ngIf="formDatosCliente.get('cP').hasError ('required')"><strong>*Este
                                campo es obligatorio</strong></mat-error>
                    </mat-form-field>
                </div>
                <!-- <div class="col-sm-12 col-md-3 col-xl-3 ">
                    <button mat-flat-button color="accent"
                        (click)="consultarCP()">Consultar</button>
                </div> -->
                <!-- <div class="col-sm-12 col-md-2 col-xl-2 ">
                    <button class="colorLetra" (click)="mostrarDatosAdicionales()" onMouseover="this.style.color='blue'" onMouseout="this.style.color='black'">Agregar datos opcionales</button>
                </div> -->
            </form>
            <h5 *ngIf="datosAdicionales">Direccion:</h5>
            <form [formGroup]="formDatosClienteAdicionales" *ngIf="datosAdicionales" class="row d-flex justify-content-start align-items-center">

                <div class="col-sm-12 col-md-12 col-xl-12 ">
                    <mat-form-field class="custom-field" appearance="fill">
                        <mat-label>Calle:</mat-label>
                        <input matInput placeholder="Calle" formControlName="calle" maxlength="30"
                            oninput="this.value = this.value.toUpperCase()"
                            onkeypress="return ((event.charCode >= 48 && event.charCode <= 57) || (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122)
                        || (event.charCode >= 44 && event.charCode <= 46) || (event.charCode == 32 || event.charCode == 209 || event.charCode == 241))" />
                        <!-- <mat-error *ngIf="formDatosClienteAdicionales.get('calle').hasError ('required')"><strong>Campo
                                Requerido</strong></mat-error> -->
                    </mat-form-field>
                </div>

                <div class="col-sm-12 col-md-6 col-xl-6 ">
                    <mat-form-field class="custom-field" appearance="fill">
                        <mat-label>No. Exterior:</mat-label>
                        <!-- <input matInput placeholder="No. Exterior" formControlName="noExterior"
                            oninput="if(this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value==0 && this.value != ''){this.value= ''}"
                            onkeypress="return ((event.charCode >= 48 && event.charCode <= 57))" /> -->
                        <input matInput placeholder="No. Exterior" formControlName="noExterior"/>
                        <!-- <mat-error *ngIf="formDatosClienteAdicionales.get('noExterior').hasError('required')">
                            <strong>Verifica
                                este campo </strong>
                        </mat-error> -->
                    </mat-form-field>
                </div>

                <div class="col-sm-12 col-md-6 col-xl-6 ">
                    <mat-form-field class="custom-field" appearance="fill">
                        <mat-label>No. Interior:</mat-label>
                        <!-- <input matInput placeholder="No. Interior" formControlName="noInterior"
                            onkeyup="if(this.value<0){this.value= this.value * -1} if(this.value == 0){this.value = ''}"
                            oninput="if(this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                            onkeypress="return ((event.charCode >= 48 && event.charCode <= 57))" /> -->
                        <input matInput placeholder="No. Interior" formControlName="noInterior" />
                        <!-- <mat-error *ngIf="formDatosClienteAdicionales.get('noInterior').hasError('required')">
                            <strong>Campo
                                Requerido </strong>
                        </mat-error> -->
                    </mat-form-field>
                </div>
                <div class="container">
                    <div class="row">
                        <div class="col-sm">
                            <mat-form-field class="custom-field" appearance="fill">
                                <mat-label>País:</mat-label>
                                <!--<input *ngIf="isPaisReadOnly" matInput placeholder="pais" formControlName="pais" [readonly]="true"/>-->
                                <mat-select [panelClass]="isPaisReadOnly ? 'hidden' : ''" [ngClass]="{'disabledsel': isPaisReadOnly}" name="pais" placeholder="Seleccione" formControlName="pais"
                                     (selectionChange)="changePais($event.value)">
                                    <mat-option *ngFor="let pais of lstPais" [value]="pais.id">
                                        {{ pais.attributes.nombre }}
                                    </mat-option>
                                </mat-select>
                                <!-- <mat-error *ngIf="formDatosClienteAdicionales.get('pais').hasError ('required')"><strong>Campo
                                        Requerido</strong></mat-error> -->
                            </mat-form-field>
                        </div>
                        <div class="col-sm">
                            <mat-form-field class="custom-field" appearance="fill">
                                <mat-label>Estado: </mat-label>
                                <mat-select [panelClass]="isEstadoReadOnly ? 'hidden' : ''" [ngClass]="{'disabledsel': isEstadoReadOnly}" name="estado" placeholder="Seleccione" formControlName="estado"
                                    (selectionChange)="changeEstado($event.value)">
                                    <mat-option *ngFor="let estado of lstEstado" [value]="estado.id">
                                        {{ estado.attributes.nombre }}
                                    </mat-option>
                                </mat-select>
                                <!-- <mat-error *ngIf="formDatosClienteAdicionales.get('estado').hasError ('required')"><strong>Campo
                                        Requerido</strong></mat-error> -->
                            </mat-form-field>
                        </div>
                        <div class="col-sm">
                            <mat-form-field class="custom-field" appearance="fill">
                                <mat-label>Municipio: </mat-label>
                                <mat-select [panelClass]="isMunicipioReadOnly ? 'hidden' : ''" [ngClass]="{'disabledsel': isMunicipioReadOnly}" name="municipio" placeholder="Seleccione" formControlName="municipio"
                                     (selectionChange)="changeMunicipio($event.value)">
                                    <mat-option *ngFor="let municipio of lstMunicipio" [value]="municipio.id">
                                        {{ municipio.attributes.nombre }}
                                    </mat-option>
                                </mat-select>
                                <!-- <mat-error *ngIf="formDatosClienteAdicionales.get('municipio').hasError ('required')">
                                    <strong>Campo
                                        Requerido</strong>
                                </mat-error> -->
                            </mat-form-field>
                        </div>
                      </div>
                      <!--<div class="row" *ngIf="!formularioCompleto"><div class="col"><span class="mat-mdc-form-field-error">No hay coincidencias en CP</span></div></div>-->
                </div>
                <div class="container">
                    <div class="row">
                        <div class="col-sm">
                            <mat-form-field class="custom-field" appearance="fill" *ngIf="!verManualmente">
                                <mat-label>Colonia: </mat-label>
                                <!-- (selectionChange)="changeColonia($event.value)" -->
                                <mat-select name="tipo" placeholder="Seleccione" formControlName="colonia" >
                                    <mat-option *ngFor="let asentamiento of lstAsentamiento"
                                        [value]="asentamiento.id">
                                        {{ asentamiento.attributes.nombre }}
                                    </mat-option>
                                </mat-select>
                                <!-- <mat-error *ngIf="formDatosClienteAdicionales.get('colonia').hasError ('required')">
                                    <strong>Campo
                                        Requerido</strong>
                                </mat-error> -->
                            </mat-form-field>

                            <mat-form-field class="custom-field" appearance="fill"  *ngIf="verManualmente">
                                <mat-label>Colonia: </mat-label>
                                <input matInput placeholder="Colonia" formControlName="coloniaManual"  minlength="1">
                            </mat-form-field>

                            <small class="floatRight" *ngIf="verManualmente">
                                <p class="buttoLikehref" (click)="changeVerManualmente()">Ver opciones</p>
                            </small>

                            <small class="floatRight" *ngIf="!verManualmente">
                                <p class="buttoLikehref" (click)="changeVerManualmente()">Ingresar manualmente</p>
                            </small>
                        </div>
                        <!-- <div class="col-sm">
                            <mat-label>Localidad: </mat-label>
                            <mat-form-field class="custom-field" appearance="fill">
                                <mat-select name="tipo" placeholder="Seleccione" formControlName="localidad"
                                    (selectionChange)="changeColonia($event.value)">
                                    <mat-option *ngFor="let asentamiento of lstAsentamiento"
                                        [value]="asentamiento.idAsentamiento">
                                        {{ asentamiento.nombre }}
                                    </mat-option>
                                </mat-select>
                                <mat-error *ngIf="formDatosClienteAdicionales.get('localidad').hasError ('required')">
                                    <strong>Campo
                                        Requerido</strong>
                                </mat-error>
                            </mat-form-field>
                        </div> -->
                    </div>
                </div>
            </form>
            <hr>
        </mat-card-content>
    </div>
</div>
</div>
<div *ngIf="csfCargado" class="row">
    <div class="col">
        <div class="alert alert-primary" role="alert">
            Antes de guardar verifique la informacion capturada
        </div>
    </div>
</div>
<div mat-dialog-actions align="end">
    <button mat-button (click)="cerrarCliente(0)">Cerrar</button>
    <div *ngIf="data.mode === 3" style="margin-left: 10pt; margin-right: 10pt;">
        <button type="button" mat-flat-button color="accent" (click)="fileInput.click()">Cargar archivo CSF</button>
        <input hidden (change)="onFileSelected()" #fileInput type="file" id="file">
    </div>
    <button *ngIf="!modificarDatos" mat-flat-button color="accent" cdkFocusInitial (click)="InsertarCliente();" [disabled]="formDatosCliente.invalid || formDatosClienteAdicionales.invalid || !isFormularioCompleto">Guardar</button><!-- [disabled]="!formularioCompleto" -->
    <button *ngIf="modificarDatos" mat-flat-button color="accent" cdkFocusInitial (click)="UPDCliente();" [disabled]="formDatosCliente.invalid || formDatosClienteAdicionales.invalid || !isFormularioCompleto">Actualizar</button>
</div>
<!-- <div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">No Thanks</button>
</div> -->
